<template>
  <div v-show="!isHideOneKeyOpenSellerPicker || !isHideNewSellerPicker" class="guide-view">
    <div class="mask-view relative-view"></div>
    <OneKeyOpenSellerPicker
      v-if="!isHideOneKeyOpenSellerPicker"
      @editGuide="editGuide"
    ></OneKeyOpenSellerPicker>
    <NewSellerPicker v-else-if="!isHideNewSellerPicker" @editGuide="editGuide"></NewSellerPicker>
  </div>
</template>

<script>
import { GuideKey } from './code'
import OneKeyOpenSellerPicker from './OneKeyOpenSellerPicker'
import NewSellerPicker from './NewSellerPicker'

export default {
  components: { OneKeyOpenSellerPicker, NewSellerPicker },
  computed: {},
  data() {
    return {
      GuideKey,
      isHideOneKeyOpenSellerPicker: true,
      isHideNewSellerPicker: true
    }
  },
  async created() {
    const isHideStepOne = await this.getGuideInfoForOneKeyOpenSellerPicker()
    // 如果第一步隐藏，第二步直接隐藏
    if (!isHideStepOne) {
      this.getGuideInfoForNewSellerPicker()
    }
  },
  methods: {
    // 是否展示'一键开启商家配送'引导页
    async getGuideInfoForOneKeyOpenSellerPicker() {
      const { success, data } = await this.$get('resourcecenter.getGuideInfo', {
        guideKey: GuideKey.one
      })
      if (success) {
        // console.log('~~~~getGuideInfo~~~~~~', data);
        const isHide = data[0].value
        this.isHideOneKeyOpenSellerPicker = isHide
        return isHide
      }
      return true
    },
    // 是否展示'去提货看看'引导页
    async getGuideInfoForNewSellerPicker() {
      const { success, data } = await this.$get('resourcecenter.getGuideInfo', {
        guideKey: GuideKey.two
      })
      if (success) {
        // console.log('~~~~getGuideInfo~~~~~~', data);
        this.isHideNewSellerPicker = data[0].value
      }
    },
    async editGuide(key, isOpen) {
      const { success, data } = await this.$get('resourcecenter.editGuideInfo', {
        guideKey: key,
        isMerchantDelivery: key === GuideKey.one ? isOpen : false
      })
      if (success) {
        switch (key) {
          case GuideKey.one:
            isOpen && this.$message.success('已成功开启“商家配送”，请关注您的待提订单')
            this.isHideOneKeyOpenSellerPicker = data[0].value
            // 如果第一步点击【下次再说】，第二个弹窗也不展示
            console.log('isOpen', isOpen)
            if (!isOpen) {
              this.isHideNewSellerPicker = true
            }
            break
          case GuideKey.two:
            this.isHideNewSellerPicker = data[0].value
        }
      }
      console.log('~~~~editGuide~~~~~~', data)
    }
  }
}
</script>

<style lang="less" scoped>
.mask-view {
  opacity: 0.6;
  background-color: #000;
  width: 100%;
  height: 100%;
  z-index: 90000;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
